module.exports = __webpack_public_path__ + "img/IMG_1539_L_Foamcore_MockedUp.66e5f766.jpg";